import wasmUrl from '@xiangqi/game-core/wasm/xiangqi_core.wasm?url';
import { loadXiangqiCoreFromUrl, type XiangqiCore } from '@xiangqi/game-core';

let corePromise: Promise<XiangqiCore> | null = null;

/** One rules engine per tab — the exact same wasm the server validates with. */
export function getCore(): Promise<XiangqiCore> {
  if (!corePromise) {
    corePromise = loadXiangqiCoreFromUrl(wasmUrl);
  }
  return corePromise;
}
